<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter2">
<div class="chapterHead">
<h2 class="chapterNumber">C<span class="smallcaps">HAPTER</span> T<span class="smallcaps">WO</span></h2>
<h2 class="chapterTitle1">Blitzkrieg, U. S. Grant Style</h2>
</div>
<p class="paraNoIndent1">The most pressing question for Grant following the victory of his forces at Willow Springs and Hankinson’s Ferry on May 3, 1863, was the direction in which to lead his army. The road north led directly to Vicksburg, but his keen appreciation of geography argued against this route. After crossing Big Black River his army would be in a narrow triangle of land bordered by the Mississippi River on the west and the Big Black River to the east and south that would restrict his ability to maneuver. Besides, he expected John Pemberton to concentrate his forces south of Vicksburg, which is exactly what the Confederate commander struggled to do that first week of May as the rugged and densely wooded area afforded him many excellent defensive positions.</p>
<p class="para">Rather than march north on Vicksburg, Grant, a master of the indirect approach, ordered his troops in a northeasterly direction and used the Big Black River to screen the movements of his army and serve as a shield on his left. (Ironically, Pemberton also used the river as a shield against Grant as he struggled to concentrate his scattered forces for the defense of Vicksburg.) It was Grant’s intention to get astride the Southern Railroad of Mississippi, which connected Vicksburg with Jackson, and sever that vital line of communications and supply. He would thus cut the Confederate garrison off from supplies and reinforcements. The long march would carry his men deep into the heart of Mississippi and be boldly made with the precision of a modern warrior—a boldness that has earned Grant the coveted distinction of being one of the great battle captains of history.<sup><span class="font01"><span href="#/TriumphandDefeat_notes#ft_ch2_1" id="ft_ch2.1" title="Link target outside of Sample">1</span></span></sup></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TriumphandDefeat_ch2.vue?0bb9dc24